import { AccountSASPermissionsLike } from '@azure/storage-blob'
import { serviceApi } from '../service-api'

export class SasTokenProvider {
  async provide(permissions: AccountSASPermissionsLike): Promise<string> {
    const param = SasTokenProvider.convertQueryParam(permissions)
    return (await serviceApi.get(`/api/security/SasToken?${param}`)).data
  }

  private static convertQueryParam(permissions: AccountSASPermissionsLike): string {
    let queryParam = ''
    if (permissions.read ?? false) {
      queryParam += 'r'
    }
    if (permissions.write ?? false) {
      queryParam += 'w'
    }
    return 'perms=' + queryParam
  }
}
